var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-toggle',{staticClass:"gl-h-5",attrs:{"value":_vm.value,"label-position":"left"},on:{"change":function($event){return _vm.$emit('change', $event)}},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticClass:"gl-font-normal gl-text-subtle"},[_vm._v(_vm._s(_vm.s__('DuoChat|Agentic')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }